import styled from 'styled-components'

export const SummaryContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.grey.tone300};
  border-top: 1px solid ${props => props.theme.colors.grey.tone300};
  padding: ${props => props.theme.whiteLabel.spacing.sp24} 0;
`

export const FeeMessagesContainer = styled.div`
  &:not(:empty) {
    margin-top: ${props => props.theme.whiteLabel.spacing.sp16};
  }
`
